import {useMutation} from "@apollo/client";

import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {GQL_ACCOUNTUSER_RESET_2FA, GQL_ACCOUNTUSERS_QUERY} from "@/lib/queries/accounts.ts";
import {AccountUser} from "@/lib/types/accounts.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

export interface UserActionReset2FAProps {
  user: AccountUser;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const UserActionReset2FA = ({user, show, setShow}: UserActionReset2FAProps) => {
  const [resetUser2FA, {data, reset, loading}] = useMutation<GraphQLResponse<null>>(GQL_ACCOUNTUSER_RESET_2FA, {
    refetchQueries: [GQL_ACCOUNTUSERS_QUERY],
  });

  const handleSubmit = async () => {
    const response = await resetUser2FA({
      variables: {
        id: user.id,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
    }
  };

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message.__all__ : [];

  return (
    <>
      <ActionDialog
        show={show}
        loading={loading}
        title={serverErrors?.length > 0 ? "Unable to Reset User 2FA" : "Reset 2FA"}
        onConfirm={handleSubmit}
        disableConfirmButton={serverErrors?.length > 0}
        cancelBtnText={serverErrors?.length > 0 ? "Close" : "Cancel"}
        confirmBtnText="OK"
        onCancel={() => {
          setShow(false);
          reset();
        }}
      >
        {serverErrors?.length > 0 ? serverErrors[0] : `Are you sure you want to reset this user's 2FA?`}
      </ActionDialog>
    </>
  );
};
